import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../config/api';
import Captcha from '../components/Captcha';

function BecomePartner() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });
  const [captchaValid, setCaptchaValid] = useState(false);
  const [captchaReset, setCaptchaReset] = useState(0);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    // Clear status when user starts typing
    if (submitStatus.message) {
      setSubmitStatus({ type: '', message: '' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate captcha before submission
    if (!captchaValid) {
      setSubmitStatus({
        type: 'error',
        message: 'Please complete the security verification (captcha) correctly before submitting.'
      });
      return;
    }

    setLoading(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const response = await api.post('/become-partner', formData);
      const data = response.data;

      if (data.success) {
        setSubmitStatus({
          type: 'success',
          message: data.message || 'Thank you for your interest in becoming a partner. We will contact you soon!'
        });
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          message: ''
        });
        // Reset captcha
        setCaptchaReset(prev => prev + 1);
      } else {
        setSubmitStatus({
          type: 'error',
          message: data.message || 'Failed to submit application. Please try again.'
        });
      }
    } catch (error) {
      console.error('Error submitting partner application:', error);
      const errorMessage = error.response?.data?.message || 
        error.message || 
        'Network error. Please check your connection and try again.';
      setSubmitStatus({
        type: 'error',
        message: errorMessage
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="page-banner bg-blue rel z-1" style={{backgroundImage: 'url(/assets/images/background/banner-bg.png)'}}>
        <div className="container">
          <div className="banner-inner">
            <h1 className="page-title wow fadeInUp delay-0-2s">Become A Partner</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb wow fadeInUp delay-0-4s">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active">Become A Partner</li>
              </ol>
            </nav>
          </div>
        </div>
        <img className="dots-shape" src="/assets/images/shapes/white-dots-two.png" alt="Shape" />
        <img className="tringle-shape slideLeftRight" src="/assets/images/shapes/white-tringle.png" alt="Shape" />
        <img className="close-shape" src="/assets/images/shapes/white-close.png" alt="Shape" />
        <img src="/assets/images/newsletter/circle.png" alt="shape" className="banner-circle slideUpRight" />
        <img className="dots-shape-three slideUpDown delay-1-5s" src="/assets/images/shapes/white-dots-three.png" alt="Shape" />
      </section>

      <section className="contact-page-section pt-130 rpt-100 pb-150 rpb-90">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-8">
              <div className="section-title text-center mb-50">
                <span className="sub-title">Partner With Us</span>
                <h2>Join Our Partner Program</h2>
                <p>Partner with Acuit CRM and help businesses transform their customer relationship management. Earn competitive commissions and grow your business with our proven CRM solution.</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="contact-content-area mr-xl-5 rmb-35 wow fadeInLeft delay-0-2s">
                <div className="section-title mb-15">
                  <h3>Why Partner With Us?</h3>
                </div>
                <ul className="list-style-one mt-30">
                  <li>Competitive commission rates</li>
                  <li>Marketing materials and support</li>
                  <li>Dedicated partner portal</li>
                  <li>Training and certification programs</li>
                  <li>Priority technical support</li>
                  <li>Co-marketing opportunities</li>
                </ul>
                <div className="mt-40">
                  <h4>Contact Information</h4>
                  <div className="contact-info-item style-two mt-20">
                    <i className="fas fa-envelope-open"></i>
                    <div className="contact-info-content">
                      <h5>Email Address</h5>
                      <span><a href="mailto:sales@plenitudeit.com.my">sales@plenitudeit.com.my</a></span>
                    </div>
                  </div>
                  <div className="contact-info-item style-two mt-20">
                    <i className="fas fa-phone"></i>
                    <div className="contact-info-content">
                      <h5>Phone Number</h5>
                      <span><a href="tel:+60327271889">+603-2727 1889</a></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="contact-form-area wow fadeInRight delay-0-2s">
                <div className="section-title">
                  <span className="sub-title">Apply Now</span>
                  <h2>Partner Application Form</h2>
                </div>
                <form className="contact-form-three pt-35" onSubmit={handleSubmit}>
                  {submitStatus.message && (
                    <div className={`alert ${submitStatus.type === 'success' ? 'alert-success' : 'alert-danger'}`} style={{
                      padding: '15px 20px',
                      marginBottom: '25px',
                      borderRadius: '5px',
                      backgroundColor: submitStatus.type === 'success' ? '#d4edda' : '#f8d7da',
                      color: submitStatus.type === 'success' ? '#155724' : '#721c24',
                      border: `1px solid ${submitStatus.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`
                    }}>
                      {submitStatus.message}
                    </div>
                  )}
                  <div className="row clearfix">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <input 
                          type="text" 
                          name="name" 
                          className="form-control" 
                          placeholder="Full Name" 
                          required 
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <input 
                          type="email" 
                          name="email" 
                          className="form-control" 
                          placeholder="Email Address" 
                          required 
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <input 
                          type="text" 
                          name="phone" 
                          className="form-control" 
                          placeholder="Phone Number" 
                          required 
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="form-group">
                        <input 
                          type="text" 
                          name="company" 
                          className="form-control" 
                          placeholder="Company Name" 
                          required 
                          value={formData.company}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <textarea 
                          name="message" 
                          rows="4" 
                          className="form-control" 
                          placeholder="Tell us about your business and why you want to partner with us" 
                          required 
                          value={formData.message}
                          onChange={handleChange}
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <Captcha 
                        onValidate={setCaptchaValid} 
                        resetTrigger={captchaReset}
                      />
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-0">
                        <button 
                          className="theme-btn" 
                          type="submit" 
                          disabled={loading || !captchaValid}
                          style={{ 
                            opacity: (loading || !captchaValid) ? 0.7 : 1, 
                            cursor: (loading || !captchaValid) ? 'not-allowed' : 'pointer' 
                          }}
                        >
                          {loading ? 'Submitting...' : 'Submit Application'} 
                          {!loading && <i className="fas fa-arrow-right"></i>}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BecomePartner;

